<h1 class="productTitle">
  <div class="productTitle__name">
    {{ product?.name }}

    <ng-container *ngIf="isColorDisplayed"> - {{ product.color.localizedName }} </ng-container>

    <span class="productTitle__like">
      <vc-sprite-icons class="svg product__likeIcon svg_heart--line" name="heart-line"></vc-sprite-icons
      >{{ product?.likeCount }}
    </span>
  </div>

  <div class="vc-title-l productTitle__brand">
    <ng-container *ngIf="product?.brand?.url.path; else productOtherBrand">
      <vc-ref resource="{{ product?.brand?.url.path }}" class="productTitle__brand__link">{{
        product?.brand?.name
      }}</vc-ref>
    </ng-container>
    <ng-template #productOtherBrand>
      <span>{{ product?.brand?.name }}</span>
    </ng-template>
  </div>
</h1>
